import Flickity from 'flickity';

export default class ProductUpdatesHighlights {
  constructor() {
    const $els = document.querySelectorAll('.js-product-updates-highlights-carousel');
    $els.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.$el = $el;

    this.flickity = new Flickity($el.querySelector('.js-carousel'), {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: false,
      contain: 'true',
      cellAlign: 'left',
      groupCells: true,
      wrapAround: true,
    });

    $el.querySelector('.js-next')?.addEventListener('click', () => {
      this.flickity.next()
    });
    $el.querySelector('.js-prev')?.addEventListener('click', () => {
      this.flickity.previous()
    });
  }
}
